import { useState } from "react";
import Card from "./UI/Card";
import Button from "./UI/Button";
import classes from "./MaaltijdenFormUpdate.module.css";

const MaaltijdenFormUpdate = (props) => {
  const existingMaaltijdIndex = props.meals.findIndex(
    (maaltijd) => maaltijd.id === props.id
  );

  const existingMaaltijd = props.meals[existingMaaltijdIndex];

  const [enteredNaam, setEnteredNaam] = useState(existingMaaltijd.naam);
  const [enteredOmschrijving, setEnteredOmschrijving] = useState(
    existingMaaltijd.omschrijving
  );
  const [enteredPrijs, setEnteredPrijs] = useState(existingMaaltijd.prijs);
  const [enteredDatum, setEnteredDatum] = useState(existingMaaltijd.datum);

  const updateMealHandler = (event) => {
    event.preventDefault();

    console.log(enteredNaam, enteredOmschrijving, enteredPrijs, enteredDatum);

    props.onUpdateMaaltijd(
      props.id,
      enteredNaam,
      enteredOmschrijving,
      enteredPrijs,
      enteredDatum
    );

    props.onToggle();
  };

  const naamChangeHandler = (event) => {
    setEnteredNaam(event.target.value);
  };

  const omschrijvingChangeHandler = (event) => {
    setEnteredOmschrijving(event.target.value);
  };

  const prijsChangeHandler = (event) => {
    setEnteredPrijs(event.target.value);
  };

  const datumChangeHandler = (event) => {
    setEnteredDatum(event.target.value);
  };

  const clearHandler = () => {
    setEnteredNaam("");
    setEnteredOmschrijving("");
    setEnteredPrijs("");
    setEnteredDatum("");
    props.onToggle();
  };

  return (
    <Card className={classes.input}>
      <form onSubmit={updateMealHandler}>
        <label htmlFor="naam">Naam</label>
        <input
          id="naam"
          type="text"
          value={enteredNaam}
          onChange={naamChangeHandler}
        />
        <label htmlFor="omschrijving">Omschrijving</label>
        <input
          id="omschrijving"
          type="text"
          value={enteredOmschrijving}
          onChange={omschrijvingChangeHandler}
        />
        <label htmlFor="prijs">Prijs</label>
        <input
          id="prijs"
          type="text"
          value={enteredPrijs}
          onChange={prijsChangeHandler}
        />
        <label htmlFor="datum">Datum</label>
        <input
          id="datum"
          type="date"
          value={enteredDatum}
          onChange={datumChangeHandler}
        />
        <Button onClick={clearHandler}>Annuleren</Button>
        <Button type="submit">Aanpassen</Button>
      </form>
    </Card>
  );
};

export default MaaltijdenFormUpdate;